import React from 'react';
import { useNavigate } from 'react-router-dom';

import { deleteSupervisingProvider } from 'api/SupervisingProvider';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';
import useModal from 'lib/hooks/useModal';

import Icon from 'components/shared/Icon/Icon';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const SupervisingProvider = ({ index, provider, autofillCMS1500, handleEditMode }) => {
  const { id, npi, f_name, m_name, l_name, address, prov_id } = provider || {};
  const navigate = useNavigate();
  const { isOpen, openModal, closeModal } = useModal();

  const mutateDeleteSupervisingProvider = useCustomMutation({
    mutationFn: () => deleteSupervisingProvider(navigate, { supervisingProviderId: id }),
    invalidateQueryKey: 'supervisingProviders',
    successMessage: 'Successfully deleted supervising provider',
    errorMessage: 'Failed to delete supervising provider',
    onSuccess: () => {
      closeModal();
    }
  });

  return (
    <>
      <div key={index} className="grid-auto-row my-3 grid">
        <div className="relative rounded-lg border bg-primary-50 p-20">
          <div className="absolute right-4 top-4 flex gap-3 ">
            <div
              onClick={() => handleEditMode({ ...provider, autofillCMS1500 })}
              data-qa="edit-btn-npi">
              <Icon icon="edit-3-mono" className="cursor-pointer" />
            </div>
            <div onClick={openModal} data-qa="delete-btn-npi">
              <Icon icon="trash-mono" className="cursor-pointer" />
            </div>
          </div>
          <div>
            <p className="text-base font-semibold">NPI: &nbsp;</p>
            <p className="text-base">{npi}</p>
          </div>
          <div>
            <p className="text-base font-semibold">First Name: &nbsp;</p>
            <p className="text-base">{f_name}</p>
          </div>
          <div>
            <p className="text-base font-semibold">Middle Name: &nbsp;</p>
            <p className="text-base">{m_name}</p>
          </div>
          <div>
            <p className="text-base font-semibold">Last Name: &nbsp;</p>
            <p className="text-base">{l_name}</p>
          </div>
          {address && (
            <div>
              <p className="text-base font-semibold">Address: &nbsp;</p>
              <p className="text-base">{`${address?.address_1}, ${address?.city} ${address?.state} ${address?.postal_code}`}</p>
            </div>
          )}

          <div>
            <p className="text-base font-semibold">Supervising Provider ID: &nbsp;</p>
            <p className="text-base">{prov_id}</p>
          </div>
          <div>
            <p className="text-base font-semibold">Autofill CMS1500: &nbsp;</p>
            <p className="text-base">{autofillCMS1500 ? 'Yes' : 'No'}</p>
          </div>
        </div>
      </div>

      <Confirm
        isOpen={isOpen}
        variant="danger"
        primaryBtnTxt="Delete"
        secondaryBtnTxt="Cancel"
        handleContinue={() => mutateDeleteSupervisingProvider.mutate()}
        title="Delete Supervising Provider"
        message="Are you sure you want to delete?"
        handleClose={closeModal}
      />
    </>
  );
};

export default SupervisingProvider;
